import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActionsPanel = () => {
  const quickActions = [
    {
      id: 1,
      title: "Gebruiker Toevoegen",
      description: "Nieuwe gebruiker aanmaken",
      icon: "UserPlus",
      color: "primary",
      action: () => console.log("Add user")
    },
    {
      id: 2,
      title: "Commissie Configureren",
      description: "Commissie structuur beheren",
      icon: "Settings",
      color: "accent",
      action: () => console.log("Configure commission")
    },
    {
      id: 3,
      title: "Rapport Exporteren",
      description: "Data exporteren naar CSV/Excel",
      icon: "Download",
      color: "success",
      action: () => console.log("Export report")
    },
    {
      id: 4,
      title: "Audit Logs",
      description: "Systeem logs bekijken",
      icon: "FileText",
      color: "secondary",
      link: "/audit-logs"
    }
  ];

  const colorClasses = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    accent: 'bg-accent/10 text-accent hover:bg-accent/20',
    success: 'bg-success/10 text-success hover:bg-success/20',
    secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20'
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
          Snelle Acties
        </h3>
        <p className="caption text-muted-foreground">
          Veelgebruikte beheer functies
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {quickActions?.map((action) => (
          action?.link ? (
            <Link
              key={action?.id}
              to={action?.link}
              className={`
                flex items-start gap-3 p-4 rounded-lg border border-border
                transition-smooth ${colorClasses?.[action?.color]}
              `}
            >
              <div className="flex-shrink-0">
                <Icon name={action?.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm text-foreground mb-1">
                  {action?.title}
                </h4>
                <p className="caption text-muted-foreground">
                  {action?.description}
                </p>
              </div>
              <Icon name="ChevronRight" size={16} className="flex-shrink-0 text-muted-foreground" />
            </Link>
          ) : (
            <button
              key={action?.id}
              onClick={action?.action}
              className={`
                flex items-start gap-3 p-4 rounded-lg border border-border text-left
                transition-smooth ${colorClasses?.[action?.color]}
              `}
            >
              <div className="flex-shrink-0">
                <Icon name={action?.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm text-foreground mb-1">
                  {action?.title}
                </h4>
                <p className="caption text-muted-foreground">
                  {action?.description}
                </p>
              </div>
              <Icon name="ChevronRight" size={16} className="flex-shrink-0 text-muted-foreground" />
            </button>
          )
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;